// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dm-0";
export var actionModalContentContainer = "_dm-1";
export var createTagButton = "_dm-2";
export var footerContainer = "_dm-7";
export var fullWidthDivider = "_dm-3";
export var hasCreateTagButton = "_dm-4";
export var noCreateTagButton = "_dm-5";
export var tagsContainer = "_dm-6";
export var tagsModalContentContainer = "_dm-8";